"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const one_1 = require("remax/one");
const classnames_1 = __importDefault(require("classnames"));
const one_2 = require("../one");
const _util_1 = require("../_util");
const common_1 = require("../common");
const prefixCls = common_1.getPrefixCls('tabs');
const heightUnit = 48;
// const prevTabs: any[] = [];
const getTabContents = (children, activeKey, animated) => {
    const tabContents = [];
    const tabs = [];
    react_1.default.Children.forEach(children, (node, index) => {
        const newNode = node;
        if (react_1.default.isValidElement(node)) {
            return (tabs.push({ key: newNode.key, tab: newNode.props.tab }) &&
                tabContents.push(react_1.default.createElement(TabContent, Object.assign({ key: newNode.key }, newNode.props, { active: activeKey === undefined
                        ? index === 0 && newNode.key
                        : String(activeKey) === newNode.key, animated: animated }))));
        }
    });
    return [tabs, tabContents];
};
const getTabIndex = (tabs, activeKey) => {
    let tIndex = 0;
    tabs.forEach((i, index) => {
        if (i.key === activeKey) {
            tIndex = index;
        }
    });
    return tIndex;
};
const Tabs = (props) => {
    const { type, direction = 'horizontal', activeKey, animated, fixed, onTabClick, headerContent, children, headerStyle, extra, titleWidth, titleSquare, titleAlign, } = props;
    // 针对同一个页面出现两个Tabs，给每个Tabs一个 UniqueID
    const TABS_TITLE_ID = react_1.useMemo(_util_1.guid, []);
    const [tabs, tabContents] = react_1.useMemo(() => getTabContents(children, activeKey, animated), [
        children,
    ]);
    // 将 activeKey 实时转化成当前 selected 的Tab，后面都将以 selected 作为当前选择的 Tab 的标志符
    const selected = react_1.useMemo(() => getTabIndex(tabs, activeKey), [activeKey, tabs]);
    const [titleWrapperLeft, setTitleWrapperLeft] = react_1.useState(0);
    const [titleNodes, setTitleNodes] = react_1.useState([]);
    react_1.useEffect(() => {
        var _a, _b;
        if (type === 'plain') {
            const query = one_2.createSelectorQuery();
            (_b = (_a = query
                .select(`.${prefixCls}-plain-${TABS_TITLE_ID}`)).scrollOffset) === null || _b === void 0 ? void 0 : _b.call(_a).exec((ret) => {
                const r = Array.isArray(ret) ? ret[0] : ret;
                setTitleWrapperLeft(-((r === null || r === void 0 ? void 0 : r.scrollLeft) || 0));
            });
        }
    }, [activeKey]);
    react_1.useEffect(() => {
        if (type === 'plain') {
            const query = one_2.createSelectorQuery();
            // 不加setTimeout的话只能获取部分的nodes(可能是部分 .anna-tabs-plain-title 节点还没来得及渲染出来)
            setTimeout(() => {
                query
                    .selectAll(`.${prefixCls}-plain-${TABS_TITLE_ID} .${prefixCls}-plain-title`)
                    .boundingClientRect()
                    .exec((ret) => {
                    const r = Array.isArray(ret) ? ret[0] : [ret];
                    const nodes = (r === null || r === void 0 ? void 0 : r.map((i) => ({
                        offsetLeft: i.left,
                        offsetWidth: i.width,
                    }))) || [];
                    // 解决切换tabbar导致页面渲染找不到相关节点(因为此时已经在跳转后一个页面，所以找不到)，从而使nodes这个数组为空，继而导致Tabs下标left重置为0。
                    nodes.length > 0 && setTitleNodes(nodes);
                });
            }, 200);
        }
    }, [tabs.length]);
    const handleTabClick = (item) => {
        onTabClick === null || onTabClick === void 0 ? void 0 : onTabClick(item);
    };
    const activeKeyStr = String(activeKey);
    const renderTabs = () => {
        if (type === 'plain') {
            const titleNode = (titleNodes === null || titleNodes === void 0 ? void 0 : titleNodes[selected]) || { offsetLeft: 0, offsetWidth: 0 };
            // 注；此处left的位置是相对于 .anna-tabs-plain 的，不是相对于手机视窗左侧的。所以如果 .anna-tabs-plain 不能
            // 占据视窗width的100%，Tabs的下标位置就会偏右。
            const left = titleNode.offsetLeft + titleNode.offsetWidth / 2;
            // 解决小程序下无法获取到元素的 offsetLeft 的问题，使用 scrollOffset 来获取 scrollLeft。
            if (titleWrapperLeft < 0) {
                // left += Math.abs(titleWrapperLeft); //不需要这一步，因为offsetLeft是相对于父元素的，而不是相对于视窗的
            }
            return (react_1.default.createElement(one_1.View, { className: classnames_1.default({
                    [`${prefixCls}-plain`]: true,
                    [`${prefixCls}-plain-center`]: titleAlign === 'center',
                    [`${prefixCls}-plain-${TABS_TITLE_ID}`]: true,
                }) },
                tabs.map((item) => (react_1.default.createElement(one_1.View, { key: item.key, className: classnames_1.default({
                        [`${prefixCls}-plain-title`]: true,
                        [`${prefixCls}-plain-center-title`]: titleAlign === 'center',
                    }), onTap: () => handleTabClick(item) }, item.tab))),
                react_1.default.createElement(one_1.View, { className: `${prefixCls}-plain-active`, style: {
                        transform: `translateX(${left}PX) translateX(-50%)`,
                    } })));
        }
        if (type === 'card') {
            return (react_1.default.createElement(one_1.View, { className: `${prefixCls}-card` }, tabs.map((item) => (react_1.default.createElement(one_1.View, { key: item.key, className: classnames_1.default({
                    [`${prefixCls}-card-title`]: true,
                    [`${prefixCls}-card-active`]: activeKeyStr === item.key,
                }), onTap: () => handleTabClick(item) }, item.tab)))));
        }
        return (react_1.default.createElement(one_1.View, { className: `${prefixCls}-slider` },
            react_1.default.createElement(one_1.View, { className: classnames_1.default({
                    [`${prefixCls}-slider-bg`]: true,
                    [`${prefixCls}-slider-bg-square`]: titleSquare,
                }) },
                react_1.default.createElement(one_1.View, { className: `${prefixCls}-slider-container` },
                    tabs.map((item) => (react_1.default.createElement(one_1.View, { key: item.key, className: `${prefixCls}-slider-title`, style: {
                            fontWeight: activeKeyStr === item.key ? 500 : 400,
                            width: titleWidth ? `${titleWidth}px` : null,
                        }, onTap: () => {
                            handleTabClick(item);
                        } }, item.tab))),
                    react_1.default.createElement(one_1.View, { className: `${prefixCls}-slider-active`, style: {
                            width: `${100 / tabs.length}%`,
                            transform: `translateX(${selected * 100}%)`,
                        } }))),
            extra));
    };
    if (direction === 'vertical') {
        return (react_1.default.createElement(one_1.View, { className: prefixCls },
            react_1.default.createElement(one_1.View, { className: `${prefixCls}-vertical` },
                react_1.default.createElement(one_1.View, { className: `${prefixCls}-vertical-sidebar` }, tabs === null || tabs === void 0 ? void 0 :
                    tabs.map((item, index) => (react_1.default.createElement(one_1.View, { key: item.key, className: `${prefixCls}-vertical-sidebar-item`, style: {
                            fontWeight: selected === index ? 500 : 400,
                            backgroundColor: selected === index ? '#FDFFFD' : '#FAFAFA',
                        }, onTap: () => handleTabClick(item) },
                        item.tab,
                        selected === index && (react_1.default.createElement(one_1.View, { className: `${prefixCls}-vertical-sidebar-top` },
                            react_1.default.createElement(one_1.View, { className: `${prefixCls}-vertical-sidebar-top-circle` }))),
                        selected === index && (react_1.default.createElement(one_1.View, { className: `${prefixCls}-vertical-sidebar-bottom` },
                            react_1.default.createElement(one_1.View, { className: `${prefixCls}-vertical-sidebar-bottom-circle` })))))),
                    react_1.default.createElement(one_1.View, { className: `${prefixCls}-vertical-sidebar-active`, style: {
                            transform: `translate3d(0, ${selected * heightUnit}PX, 0)`,
                        } })),
                react_1.default.createElement(one_1.View, { className: `${prefixCls}-vertical-content` }, tabContents))));
    }
    return (react_1.default.createElement(one_1.View, { className: prefixCls },
        react_1.default.createElement(one_1.View, { className: classnames_1.default(`${prefixCls}-header`, {
                [`${prefixCls}-header-fixed`]: fixed,
            }), style: Object.assign({}, headerStyle) },
            renderTabs(),
            react_1.default.createElement(one_1.View, { className: `${prefixCls}-header-content` }, headerContent)),
        react_1.default.createElement(one_1.View, { className: `${prefixCls}-content` },
            react_1.default.createElement(one_1.View, { className: `${prefixCls}-content-wrapper`, style: animated
                    ? {
                        transition: `all 0.3s ease`,
                        transform: `translate3d(${-selected * 100}%, 0, 0)`,
                    }
                    : {} }, tabContents))));
};
const TabContent = (props) => {
    const { active, style, animated, children } = props;
    if (!active) {
        return (react_1.default.createElement(one_1.View, { className: classnames_1.default(`${prefixCls}-content-tab`, {
                [`${prefixCls}-content-tab-inactive`]: !animated,
                [`${prefixCls}-content-tab-inactive-animated`]: animated,
            }), style: style }, children));
    }
    return (react_1.default.createElement(one_1.View, { className: `${prefixCls}-content-tab`, style: style }, children));
};
Tabs.TabContent = TabContent;
exports.default = Tabs;
